import { TEAM_TYPES } from 'common/constants/constants';
import _ from 'lodash';
import {
  METRICS_GROUP_BY_API_PARAMS,
  METRICS_GROUP_BY_OPTIONS
} from './custom-report.serivce';
import { isEqualAllTeams } from './Filters/TeamsDropdown';

export const getMetricsGroupByV3 = ({
  globallySelectedTeams,
  isCustomPMMetrics,
  selectedRepo,
  selectedService,
  selectedLabels,
  allTeamsGroupId
} = {}) => {
  if (isCustomPMMetrics) {
    return {
      apiParam: METRICS_GROUP_BY_API_PARAMS.CUSTOM_METRIC
    };
  }
  if (!_.isEmpty(selectedLabels)) {
    return {
      key: METRICS_GROUP_BY_OPTIONS.LABEL,
      apiParam: METRICS_GROUP_BY_API_PARAMS.ORGANIZATION,
      group: []
    };
  }

  const isTeamAllTeamsGroup =
    allTeamsGroupId && globallySelectedTeams?.[0]?.id === allTeamsGroupId;

  const isSelectedTeamAllContributors =
    globallySelectedTeams?.[0]?.type === TEAM_TYPES.ALL_CONTRIBUTORS;

  if (
    !isSelectedTeamAllContributors &&
    !(isTeamAllTeamsGroup || isEqualAllTeams(globallySelectedTeams)) &&
    // THIS IS A TEMP FIX UNTIL THE UI SUPPORTS COMPLEX FILTERING
    _.isEmpty(selectedService) &&
    _.isEmpty(selectedRepo) &&
    _.isEmpty(selectedLabels)
  ) {
    return {
      key: METRICS_GROUP_BY_OPTIONS.TEAM,
      apiParam: METRICS_GROUP_BY_API_PARAMS.TEAM,
      group: globallySelectedTeams
    };
  }
  return {
    key: METRICS_GROUP_BY_OPTIONS.ORGANIZATION,
    apiParam: METRICS_GROUP_BY_API_PARAMS.ORGANIZATION,
    group: []
  };
};
